module.exports = __webpack_public_path__ + "img/58.4.NH3-N.2cdbeffa.png";